package kz.dentalcrm.app.screens.quick_replies.edit

import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.error_message
import dentalcrm.composeapp.generated.resources.snackbar_quick_reply_deleted
import dentalcrm.composeapp.generated.resources.snackbar_quick_reply_updated
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply
import kz.dentalcrm.app.domain.QuickRepliesRepository
import kz.dentalcrm.app.screens.quick_replies.edit.mvi.EditQuickReplyViewEvent
import kz.dentalcrm.app.screens.quick_replies.edit.mvi.EditQuickReplyViewSideEffect
import kz.dentalcrm.app.screens.quick_replies.edit.mvi.EditQuickReplyViewState
import kz.dentalcrm.app.theme.SnackbarController
import kz.dentalcrm.app.theme.SnackbarEvent
import org.jetbrains.compose.resources.getString
import org.koin.core.component.inject

class EditQuickReplyViewModel :
    BaseStateViewModel<EditQuickReplyViewEvent, EditQuickReplyViewState, EditQuickReplyViewSideEffect>() {

    private val quickRepliesRepository: QuickRepliesRepository by inject()

    override fun setInitialState() = EditQuickReplyViewState()

    override fun handleEvents(event: EditQuickReplyViewEvent) {
        when (event) {
            is EditQuickReplyViewEvent.EditQuickReply -> editQuickReply(event.quickReply, event.message)
            is EditQuickReplyViewEvent.DeleteQuickReply -> deleteQuickReply(event.quickReply)
            EditQuickReplyViewEvent.Reset -> setState { copy(screenState = EditQuickReplyViewState.ScreenState.Idle) }
        }
    }

    private fun editQuickReply(quickReply: QuickReply, message: String) {
        setState { copy(screenState = EditQuickReplyViewState.ScreenState.Editing) }
        launch(Dispatchers.Default) {
            when (val result = quickRepliesRepository.updateQuickReply(id = quickReply.id, message = message)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_quick_reply_updated), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = EditQuickReplyViewState.ScreenState.Edited) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState { copy(screenState = EditQuickReplyViewState.ScreenState.Error(error = result.message ?: "Неизвестная ошибка")) }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState { copy(screenState = EditQuickReplyViewState.ScreenState.Error(error = "Неизвестная ошибка")) }
                }
            }
        }
    }

    private fun deleteQuickReply(quickReply: QuickReply) {
        setState { copy(screenState = EditQuickReplyViewState.ScreenState.Editing) }
        launch(Dispatchers.Default) {
            when (val result = quickRepliesRepository.deleteQuickReply(id = quickReply.id)) {
                is Result.Success -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.snackbar_quick_reply_deleted), SnackbarEvent.SnackbarType.Green))
                    setState { copy(screenState = EditQuickReplyViewState.ScreenState.Deleted) }
                }
                is Result.Error -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState { copy(screenState = EditQuickReplyViewState.ScreenState.Error(error = result.message ?: "Неизвестная ошибка")) }
                }
                else -> {
                    SnackbarController.sendEvent(SnackbarEvent(getString(Res.string.error_message), SnackbarEvent.SnackbarType.Red))
                    setState { copy(screenState = EditQuickReplyViewState.ScreenState.Error(error = "Неизвестная ошибка")) }
                }
            }
        }
    }

    override fun onCleared() {
        setState { EditQuickReplyViewState() }
    }
}
